import {
  verifyRecoveryTokenApi,
  fetchAuthorizedUserApi,
  setPasswordApi,
  signInApi,
  signOutApi,
  getAuthenticationMethod,
  sendMigrateEmail,
  fetchAuthorizedUserApiOkta,
} from "api/auth";
import {fetchConfigurationsFinancialInstitutionApi, fetchConfigurationsWhiteLabelApi} from "api/configurations";
import {getTheme} from "store/selectors/theme";
import {Configuration} from "types/configurations";
import {Theme} from "types/theme";
import {fetchThemeApi} from "../../api/theme";
import {changeUserLanguageApi, fetchUserApi} from "../../api/user";
import {OperationType} from "../../types/operation";
import {Operation} from "./Operation";
import {IdTokenClaims} from "oidc-client-ts";
import {CustomUserClaims} from "@okta/okta-auth-js";
import {AuthenticationMethod} from "~/types/enums/authenticationMethod";

export const fetchThemeOperation = new Operation<Theme>(
  OperationType.fetchTheme,
  fetchThemeApi,
  getTheme
);

export const fetchWhiteLabelConfigurationsOperation = new Operation<Configuration[]>(
  OperationType.fetchWhitelabelConfigurations,
  fetchConfigurationsWhiteLabelApi
);

export const fetchProviderConfigurationsOperation = new Operation<Configuration[]>(
  OperationType.fetchProviderConfigurations,
  fetchConfigurationsFinancialInstitutionApi
);

export const fetchAuthorizedUserOperation = new Operation<IdTokenClaims>(
  OperationType.fetchAuthorizedUser,
  fetchAuthorizedUserApi
);

// TODO: Delete this!
export const fetchAuthorizedUserOperationOkta = new Operation<CustomUserClaims>(
  OperationType.fetchAuthorizedUserOkta,
  fetchAuthorizedUserApiOkta
);

export const signInOperation = new Operation(OperationType.signIn, signInApi);

export const fetchAuthenticationMethod = new Operation<AuthenticationMethod>(OperationType.fetchAuthenticationMethod, getAuthenticationMethod);

export const sendMigrationEmailMethod = new Operation(OperationType.sendMigrationEmail, sendMigrateEmail);

export const signOutOperation = new Operation(OperationType.signOut, signOutApi);

export const setPasswordOperation = new Operation(OperationType.setPassword, setPasswordApi);

export const verifyRecoveryTokenOperation = new Operation(
  OperationType.verifyRecoveryToken,
  verifyRecoveryTokenApi
);

export const fetchUserApiOperation = new Operation(OperationType.fetchUser, fetchUserApi);

export const changeLanguageOperation = new Operation(
  OperationType.changeLanguage,
  changeUserLanguageApi
);
